export interface GliderColorTokenSwatch {
  cssVar: string;
  description: string;
  label: string;
  textVar?: string;
}

export const gliderSemanticColorTokens = [
  {
    cssVar: "background",
    description: "Base app canvas",
    label: "Background",
    textVar: "foreground",
  },
  {
    cssVar: "foreground",
    description: "Primary text and icon color",
    label: "Foreground",
    textVar: "background",
  },
  {
    cssVar: "card",
    description: "Default card surface",
    label: "Card",
    textVar: "card-foreground",
  },
  {
    cssVar: "card-foreground",
    description: "Text and icons on card surfaces",
    label: "Card Foreground",
    textVar: "card",
  },
  {
    cssVar: "popover",
    description: "Overlay content surface",
    label: "Popover",
    textVar: "popover-foreground",
  },
  {
    cssVar: "popover-foreground",
    description: "Text and icons on popovers",
    label: "Popover Foreground",
    textVar: "popover",
  },
  {
    cssVar: "primary",
    description: "Primary action and emphasis",
    label: "Primary",
    textVar: "primary-foreground",
  },
  {
    cssVar: "primary-foreground",
    description: "Content rendered on primary fills",
    label: "Primary Foreground",
    textVar: "primary",
  },
  {
    cssVar: "secondary",
    description: "Secondary surface and pills",
    label: "Secondary",
    textVar: "secondary-foreground",
  },
  {
    cssVar: "secondary-foreground",
    description: "Content rendered on secondary fills",
    label: "Secondary Foreground",
    textVar: "secondary",
  },
  {
    cssVar: "muted",
    description: "Subtle fills and sections",
    label: "Muted",
    textVar: "muted-foreground",
  },
  {
    cssVar: "muted-foreground",
    description: "Subtle copy, neutral icons, and quiet state color",
    label: "Muted Foreground",
    textVar: "background",
  },
  {
    cssVar: "accent",
    description: "Hover and focus-adjacent emphasis",
    label: "Accent",
    textVar: "accent-foreground",
  },
  {
    cssVar: "accent-foreground",
    description: "Content rendered on accent fills",
    label: "Accent Foreground",
    textVar: "accent",
  },
  {
    cssVar: "selected",
    description: "Selected control and row surface",
    label: "Selected",
    textVar: "foreground",
  },
  {
    cssVar: "hover",
    description: "Neutral hover-state overlay",
    label: "Hover",
    textVar: "foreground",
  },
  {
    cssVar: "active",
    description: "Neutral active-state overlay",
    label: "Active",
    textVar: "foreground",
  },
  {
    cssVar: "destructive",
    description: "Critical and destructive fills and borders",
    label: "Destructive",
    textVar: "destructive-foreground",
  },
  {
    cssVar: "destructive-foreground",
    description: "Content rendered on destructive fills",
    label: "Destructive Foreground",
    textVar: "destructive",
  },
  {
    cssVar: "border",
    description: "Universal divider and stroke token",
    label: "Border",
    textVar: "foreground",
  },
  {
    cssVar: "input",
    description: "Field and control surface",
    label: "Input",
    textVar: "foreground",
  },
  {
    cssVar: "ring",
    description: "Focus halo and selection ring",
    label: "Ring",
    textVar: "foreground",
  },
  {
    cssVar: "modal-overlay",
    description: "Theme-aware modal and dialog scrim",
    label: "Modal Overlay",
    textVar: "foreground",
  },
  {
    cssVar: "status-positive-foreground",
    description: "Readable positive, gain, and success content",
    label: "Positive Foreground",
    textVar: "background",
  },
  {
    cssVar: "status-negative-foreground",
    description: "Readable negative, loss, and error content",
    label: "Negative Foreground",
    textVar: "background",
  },
  {
    cssVar: "status-warning-foreground",
    description: "Readable warning and stale-state content",
    label: "Warning Foreground",
    textVar: "background",
  },
  {
    cssVar: "status-info-foreground",
    description: "Readable informational content",
    label: "Info Foreground",
    textVar: "background",
  },
  {
    cssVar: "status-pending-foreground",
    description: "Readable pending and awaiting-review content",
    label: "Pending Foreground",
    textVar: "background",
  },
  {
    cssVar: "chart-1",
    description: "Primary chart series",
    label: "Chart 1",
  },
  {
    cssVar: "chart-2",
    description: "Secondary chart series",
    label: "Chart 2",
  },
  {
    cssVar: "chart-3",
    description: "Tertiary chart series",
    label: "Chart 3",
  },
  {
    cssVar: "chart-4",
    description: "Quaternary chart series",
    label: "Chart 4",
  },
  {
    cssVar: "chart-5",
    description: "Fifth chart series",
    label: "Chart 5",
  },
  {
    cssVar: "chart-value-stroke",
    description: "Full-strength value-series line",
    label: "Chart Value Stroke",
  },
  {
    cssVar: "chart-drawdown-stroke",
    description: "Full-strength risk and drawdown outline",
    label: "Chart Drawdown Stroke",
    textVar: "background",
  },
  {
    cssVar: "chart-drawdown-fill",
    description: "Low-alpha risk and drawdown underlay",
    label: "Chart Drawdown Fill",
  },
  {
    cssVar: "chart-flow-bars",
    description: "Neutral chart flow bars",
    label: "Chart Flow Bars",
  },
  {
    cssVar: "chart-heatmap-neutral-fill",
    description: "Flat or unavailable market heatmap fill",
    label: "Heatmap Neutral",
  },
  {
    cssVar: "chart-heatmap-positive-1",
    description: "Lowest positive market heatmap magnitude",
    label: "Heatmap Positive 1",
  },
  {
    cssVar: "chart-heatmap-positive-2",
    description: "Low positive market heatmap magnitude",
    label: "Heatmap Positive 2",
  },
  {
    cssVar: "chart-heatmap-positive-3",
    description: "High positive market heatmap magnitude",
    label: "Heatmap Positive 3",
  },
  {
    cssVar: "chart-heatmap-positive-4",
    description: "Highest positive market heatmap magnitude",
    label: "Heatmap Positive 4",
  },
  {
    cssVar: "chart-heatmap-negative-1",
    description: "Lowest negative market heatmap magnitude",
    label: "Heatmap Negative 1",
  },
  {
    cssVar: "chart-heatmap-negative-2",
    description: "Low negative market heatmap magnitude",
    label: "Heatmap Negative 2",
  },
  {
    cssVar: "chart-heatmap-negative-3",
    description: "High negative market heatmap magnitude",
    label: "Heatmap Negative 3",
  },
  {
    cssVar: "chart-heatmap-negative-4",
    description: "Highest negative market heatmap magnitude",
    label: "Heatmap Negative 4",
  },
  {
    cssVar: "chart-heatmap-foreground",
    description: "Labels on chromatic market heatmap fills",
    label: "Heatmap Foreground",
  },
  {
    cssVar: "chart-heatmap-neutral-foreground",
    description: "Labels on neutral market heatmap fills",
    label: "Heatmap Neutral Foreground",
  },
  {
    cssVar: "portfolio-trend-positive",
    description: "Positive portfolio trend content",
    label: "Positive Trend",
    textVar: "background",
  },
  {
    cssVar: "portfolio-trend-negative",
    description: "Negative portfolio trend content",
    label: "Negative Trend",
    textVar: "background",
  },
] as const satisfies readonly GliderColorTokenSwatch[];

export const gliderSidebarColorTokens = [
  {
    cssVar: "sidebar",
    description: "Sidebar body surface",
    label: "Sidebar",
    textVar: "sidebar-foreground",
  },
  {
    cssVar: "sidebar-foreground",
    description: "Primary sidebar content",
    label: "Sidebar Foreground",
    textVar: "sidebar",
  },
  {
    cssVar: "sidebar-primary",
    description: "Primary CTA in rail contexts",
    label: "Sidebar Primary",
    textVar: "sidebar-primary-foreground",
  },
  {
    cssVar: "sidebar-primary-foreground",
    description: "Content rendered on sidebar primary fills",
    label: "Sidebar Primary Foreground",
    textVar: "sidebar-primary",
  },
  {
    cssVar: "sidebar-accent",
    description: "Sidebar hover and active state",
    label: "Sidebar Accent",
    textVar: "sidebar-accent-foreground",
  },
  {
    cssVar: "sidebar-accent-foreground",
    description: "Content rendered on sidebar accent fills",
    label: "Sidebar Accent Foreground",
    textVar: "sidebar-accent",
  },
  {
    cssVar: "sidebar-border",
    description: "Sidebar dividers and outlines",
    label: "Sidebar Border",
    textVar: "sidebar-foreground",
  },
  {
    cssVar: "sidebar-ring",
    description: "Sidebar focus indicator",
    label: "Sidebar Ring",
    textVar: "sidebar",
  },
] as const satisfies readonly GliderColorTokenSwatch[];

export const gliderExtensionColorTokens = [
  {
    cssVar: "brand-mint-50",
    description: "Light atmospheric mint",
    label: "Mint 50",
  },
  {
    cssVar: "brand-mint-100",
    description: "Focus halo mint",
    label: "Mint 100",
  },
  {
    cssVar: "brand-mint-200",
    description: "Primary Glider mint",
    label: "Mint 200",
  },
  {
    cssVar: "brand-olive-100",
    description: "Olive support tone",
    label: "Olive 100",
  },
  {
    cssVar: "brand-green-readable",
    description: "Mode-aware readable Glider green",
    label: "Readable Green",
  },
  {
    cssVar: "accent-blue-100",
    description: "Soft blue highlight",
    label: "Blue 100",
  },
  {
    cssVar: "accent-blue-200",
    description: "Sharper cyan-blue support",
    label: "Blue 200",
  },
  {
    cssVar: "chart-blue",
    description: "Chart and data-viz blue",
    label: "Chart Blue",
  },
  {
    cssVar: "green-accent-1000",
    description: "Positive state accent",
    label: "Positive Accent",
  },
  {
    cssVar: "warning-accent-1000",
    description: "Warning state accent",
    label: "Warning Accent",
  },
  {
    cssVar: "red-accent-1000",
    description: "Negative state accent",
    label: "Negative Accent",
  },
  {
    cssVar: "black-500",
    description: "Soft neutral ink",
    label: "Black 500",
    textVar: "destructive-foreground",
  },
  {
    cssVar: "black-600",
    description: "Mid neutral ink",
    label: "Black 600",
    textVar: "destructive-foreground",
  },
  {
    cssVar: "black-700",
    description: "Default dark surface",
    label: "Black 700",
    textVar: "destructive-foreground",
  },
  {
    cssVar: "black-800",
    description: "Deep neutral surface",
    label: "Black 800",
    textVar: "destructive-foreground",
  },
  {
    cssVar: "black-900",
    description: "Deep dark shell",
    label: "Black 900",
    textVar: "destructive-foreground",
  },
  {
    cssVar: "black-1000",
    description: "Absolute black anchor",
    label: "Black 1000",
    textVar: "destructive-foreground",
  },
  {
    cssVar: "glider-highlight",
    description: "Legacy highlight for bespoke UI",
    label: "Highlight",
  },
  {
    cssVar: "glider-highlight-hover",
    description: "Highlight interaction state",
    label: "Highlight Hover",
  },
  {
    cssVar: "glider-error",
    description: "Glider error accent",
    label: "Glider Error",
  },
  {
    cssVar: "execution-live-green",
    description: "Reserved for live, actively executing operations",
    label: "Live Execution",
  },
] as const satisfies readonly GliderColorTokenSwatch[];

export const gliderStatusToneClassNames = {
  default: "[--glider-tone-color:var(--muted-foreground)]",
  info: "[--glider-tone-color:var(--status-info-foreground)]",
  success: "[--glider-tone-color:var(--status-positive-foreground)]",
  warning: "[--glider-tone-color:var(--status-warning-foreground)]",
  destructive: "[--glider-tone-color:var(--status-negative-foreground)]",
  pending: "[--glider-tone-color:var(--status-pending-foreground)]",
} as const;

export type GliderStatusTone = keyof typeof gliderStatusToneClassNames;
